async function copyToClipboard(
    data,
    onSuccess = () => {},
    onError = null
) {
    // Sem a API de clipboard (http em rede local, navegador antigo) o caminho
    // feliz nem existe: cai direto no fallback, senão o clique não faz nada.
    if (!navigator?.clipboard?.writeText) {
        runFallback(data, onSuccess, onError)
        return
    }

    try {
        await navigator.clipboard.writeText(data)
        onSuccess()
    } catch (error) {
        runFallback(data, onSuccess, onError)
    }
}

function runFallback(data, onSuccess, onError) {
    if (onError) {
        onError()
        return
    }

    copyToClipboardFallback(data)
    onSuccess()
}

function copyToClipboardFallback(value) {
    const input = document.createElement('input');
    input.value = value;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
}

export {
    copyToClipboard,
    copyToClipboardFallback,
}
